import { TieringMode } from '../../models/enums';
import { Filter } from '../../models/filter-models';
import { Tier } from '../../models/item-data-models';
import { TieringCutoffHint, TieringCutoffHintSubject } from '../../models/tiering-cutoff-hint.models';
import { CurrencyTierService } from './currency-tier.service';
import { UniquesTierService } from './uniques-tier.service';

export function buildTieringCutoffHint(
  subject: TieringCutoffHintSubject,
  mode: TieringMode,
  filter: Filter,
  currencyTierService: CurrencyTierService,
  uniquesTierService: UniquesTierService,
): TieringCutoffHint | null {
  if (subject === 'currency') {
    const display = currencyTierService.getDisplayValueForMode(mode, Tier.FHidden, filter);
    if (!display) return null;
    const hidden = currencyTierService.getMostValuableHiddenItemsForMode(mode, 3, filter);
    return {
      ...display,
      subject: 'currency',
      exampleItems: hidden.names,
      hiddenCount: hidden.total,
    };
  }

  if (subject === 'divCards') {
    const display = currencyTierService.getDisplayValueForMode(mode, Tier.FHidden, filter, true);
    if (!display) return null;
    const hidden = currencyTierService.getMostValuableHiddenItemsForMode(mode, 3, filter, true);
    return {
      ...display,
      subject: 'divCards',
      exampleItems: hidden.names,
      hiddenCount: hidden.total,
    };
  }

  const display = uniquesTierService.getDisplayValueForMode(mode, 'Other', filter);
  if (!display) return null;
  const other = uniquesTierService.getMostValuableOtherItemsForMode(mode, 3, filter);
  return {
    ...display,
    subject: 'uniques',
    exampleItems: other.names,
    hiddenCount: other.total,
  };
}
